// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uVmhm","title":"styles_title__AnTEy"};